<template>
  <div class="news-list maxW">
    <div class="news-list-content clear">
      <div class="list-content-l fl">
        <div class="title">
          <p>新闻公告</p>
          <p>NEWS BULLETIN</p>
        </div>
        <ul>
          <!-- :style="{'border-bottom':(categoryData.length-1)===index &&  '1px solid #BBBBBB'}" -->
          <li v-for="(item, index) of categoryData" :key="index" 
            :class="[item.id == category.id ? 'list-item active' : 'list-item']" @click="getNewsList(item)">
            {{ item.name }}<i class="el-icon-arrow-right"></i>
          </li>
        </ul>
        <p v-if="placeholder">- {{ $t("global.noCate") }} -</p>
      </div>
      <div class="list-content-r fr">
        <h3 v-if="category.name">{{ category.name }}</h3>
        <ul>
          <li class="list-item clear" v-for="(item1, index1) of newsListData" :key="index1">
            <router-link class="news-poster fl" :to="{ path: '/home/newsDetail', query: { id: item1.id } }">
              <img v-if="item1.picture != ''" :src="BASE_URL + item1.picture" />
              <div v-else class="no-poster">
                - {{ $t("global.noPoster") }} -
              </div>
            </router-link>
            <div class="news-info">
              <router-link class="news-name" :to="{ path: '/home/newsDetail', query: { id: item1.id } }"><span>{{
                item1.name }}</span><span v-if="item1.top == 1">{{
    $t("global.top")
  }}</span></router-link>
              <!-- 将图片转为文字 -->
              <div class="news-content" v-html="item1.content.replace(reg, $t('global.image'))"></div>
              <p class="creater-info">
                <img v-if="item1.avatar_path" :src="item1.avatar_path" alt="" /><span>{{ item1.username }}</span><span>{{
                  item1.create_time.split(' ')[0] }}</span><span>{{ item1.clicks }}{{ $t("global.check") }}</span>
              </p>
            </div>
          </li>
        </ul>

        <div class="page-box" v-if="data_sum > page_size">
          <el-pagination @current-change="changePage" :page-size="page_size" :current-page="page_index"
            layout="total,prev, pager, next,jumper" :total="data_sum">
          </el-pagination>
        </div>

        <div class="news-placeholder" v-if="placeholder">
          {{ $t("global.noData") }}
          <!-- <img src="../../../assets/images/news-list.png" alt="123"> -->
        </div>

        <div class="news-placeholder" v-if="imgPlaceholder">
          {{ $t("global.noData") }}
          <!-- <img src="../../../assets/images/news-list.png" alt="456"> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      categoryData: [], //左侧公告分类数据
      category: {}, //选中的分类
      newsListData: [], //右侧公告列表数据
      reg: /<img[^>]*src[=\"\'\s]+[^\.]*\/([^\.]+)\.[^\"\']+[\"\']?[^>]*>/gi, // 检索图片正则
      // 右侧分页
      page_index: 1,
      page_size: 5,
      data_sum: 0,
      placeholder: false,
      imgPlaceholder: false,
    };
  },
  created() {
    this.getCategory();
  },
  methods: {
    // 获取左侧公告分类数据
    getCategory() {
      let success = (res) => {
        this.categoryData = res.data;
        res.data.length != 0 ? this.getNewsList(res.data[0]) : "";
        this.placeholder = res.data.length > 0 ? false : true;
      };
      this.$ajax({
        url: "api/news/news_category",
        method: "get",
        params: {
          status: 1,
        },
        func: {
          success: success,
        },
      });
    },
    //根据公告分类的id去获取对应的新闻列表信息
    getNewsList(item) {
      this.category = item;
      let success = (res) => {
        // console.log(res.data,'闻列表信息')
        this.newsListData = deep_clone(res.data.data);
        this.newsListData.forEach(item => {
          if (item.avatar_path.includes('/static/default/user_preview-1.png') || item.avatar_path.includes('/public/picture')) {
            item.avatar_path = this.BASE_URL + item.avatar_path
          }
        })
        this.data_sum = res.data.data_sum;
        this.imgPlaceholder = this.newsListData.length > 0 ? false : true;
      };
      this.$ajax({
        url: "api/news/news_list",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          DecisionPlatform: "logintable",
        },
        method: "get",
        params: {
          category_id: item.id,
          page_index: this.page_index,
          page_size: this.page_size,
          order: "top",
        },
        func: {
          success: success,
        },
      });
    },
    //分页
    changePage(val) {
      this.page_index = val;
      this.getNewsList(this.category);
    },
  },
};
</script>
<style lang="scss">
.news-list {
  padding-top: 20px;
  padding-bottom: 40px;

  .top-menu {
    margin: 30px 0 20px;
  }

  .news-list-content {
    margin: auto;
    margin-top: 11%;
  }

  .title {
    padding: 10px 20px;

    p:nth-child(1) {
      font-size: 24px;
      font-weight: bold;
      line-height: 32px;
    }

    p:nth-child(2) {
      font-size: 16px;
      line-height: 21px;
      font-family: MicrosoftYaHei;
      color: #BBBBBB;
    }
  }

  .list-content-l {
    display: inline-block;
    width: 240px;
    background-color: #fff;
    padding: 10px 0;

    >p {
      color: #999;
      font-size: 16px;
      text-align: center;
      padding: 60px 0;
    }

    .list-item {
      height: 60px;
      line-height: 60px;
      text-indent: 26px;
      color: #666;
      position: relative;
      cursor: pointer;
      font-size: 14px;
      border-top: 1px solid #BBBBBB;

      i {
        position: absolute;
        top: 22px;
        right: 20px;
      }
    }

    .active {
      // background: #FFDBE4;
      color: #E62125;
      font-weight: bold;
    }
  }

  .list-content-r {
    display: inline-block;
    width: calc(100% - 260px);
    background-color: #fff;
    padding: 20px 40px;
    box-sizing: border-box;

    .news-placeholder {
      text-align: center;
      padding: 80px 0;
    }

    h3 {
      font-size: 16px;
      font-weight: bold;
      line-height: 20px;
      margin-bottom: 20px;
      color: #000;
    }

    .list-item:first-of-type {
      border-top: 1px solid #efefef;
    }

    .list-item {
      padding: 20px 0;
      border-bottom: 1px solid #efefef;
    }

    .news-poster {
      display: inline-block;
      width: 240px;
      height: 135px;
      border: 1px solid #ddd;
      text-align: center;

      >img {
        object-fit: contain;
        // width: 100%;
        height: 100%;
      }
    }

    .news-info {
      overflow: hidden;
      display: inline-block;
      width: calc(100% - 242px);
      padding: 0 20px;
      box-sizing: border-box;
      height: 137px;
      color: #333;

      .news-name {
        display: block;
        font-size: 18px;

        >span {
          line-height: 24px;

          &:nth-child(2) {
            display: inline-block;
            margin-left: 13px;
            width: 45px;
            font-size: 16px;
            text-align: center;
            background: #e93f68;
            color: #fff;
            border-radius: 3px;
          }
        }
      }

      .news-content {
        margin-top: 16px;
        width: 100%;
        // height: 80px;
        // line-height: normal;
        // overflow: hidden;
        // text-overflow: ellipsis;
        // display: -webkit-box;
        // -webkit-line-clamp: 4;
        // -webkit-box-orient: vertical;
        word-wrap: break-word;
        word-break: break-all;
        overflow-y: scroll;
        overflow: hidden;
        height: 40px;
        line-height: 20px;
      }

      .creater-info {
        margin-top: 20px;
        height: 26px;
        line-height: 26px;
        color: #888888;
        font-size: 12px;

        img {
          width: 26px;
          height: 26px;
          margin-right: 10px;
          border-radius: 50%;
        }

        span:nth-child(3) {
          margin: 0 10px;
        }
      }
    }
  }

  .no-poster {
    height: 100%;
    text-align: center;
    vertical-align: middle;
    line-height: 180px;
    color: #ccc;
  }

  .page-box {
    height: 52px;
    padding-top: 20px;
  }
}</style>
